define([
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min'
], function riqToastrStateMutationModule(aoflModules) {
  'use strict';
  var mutations = function mutations() {
    var objectUtils = aoflModules.objectUtils;
    var toastrMutations = {
      /**
       * Init state
       * @function init
       * @return {Object} - new state
       **/
      init: function init() {
        var state = {};
        return state;
      },
      /**
       * Update toastr show property in state
       * @function show
       * @param {Object} _moduleState - state of the toastr
       * @param {String} _payload - new toastr
       * @return {Object} - updated state
       **/
      show: function show(_moduleState, _payload) {
        var toastrKey;
        var nextModuleState = _moduleState;
        if (typeof _payload === 'object') {
          toastrKey = _payload.toastrKey;
        } else {
          toastrKey = _payload;
        }

        if (typeof _moduleState[toastrKey] !== 'undefined') {
          nextModuleState = this.hide(_moduleState, _payload);
          return objectUtils.deepAssign(nextModuleState, toastrKey, {
            show: true,
            type: _payload.type,
            message: _payload.message,
            title: _payload.title,
            options: _payload.options
          });
        }
        return nextModuleState;
      },
      /**
       * Update toastr show property in state
       * @function hide
       * @param {Object} _moduleState - state of the toastr
       * @param {String} _payload - new toastr
       * @return {Object} - updated state
       **/
      hide: function hideToastr(_moduleState) {
        var nextModuleState = _moduleState;
        for (var i in nextModuleState) {
          if (nextModuleState[i]) {
            nextModuleState = objectUtils.deepAssign(nextModuleState, i, {
              show: false
            });
          }
        }
        return nextModuleState;
      },
      /**
       * Register toastrs in state
       * @function register
       * @param {Object} _moduleState - state of the toastrs
       * @param {String} _payload - new toasts
       * @return {Object} - updated state
       **/
      register: function registerModal(_moduleState, _payload) {
        var modalKey = _payload;
        var nextModuleState = Object.assign({}, _moduleState);
        nextModuleState[modalKey] = {
          show: false
        };
        return nextModuleState;
      }
    };
    return toastrMutations;
  };

  return mutations;
});
